// extracted by mini-css-extract-plugin
module.exports = {"emoji":"about-module--emoji--3kHxA","link__medgrocer":"about-module--link__medgrocer--KKV5y","header":"about-module--header--1aC5O"};